import React from "react";
import { SideMenu } from "../../features/side_menu/SideMenu";
import { PageContainer } from "../page_container/PageContainer";
import { useLanguageFromUrl } from "../../app/hooks";

interface SideMenuPageContainerProps {
  pageSeoTitle: string;
  pageTitle: string;
  pageDescription: string;
  children?: React.ReactNode;
}

export function SideMenuPageContainer(props: SideMenuPageContainerProps) {
  // Automatically detect and change language when URL changes
  useLanguageFromUrl();

  return (
    <SideMenu 
      pageTitle={props.pageTitle}>
      <PageContainer
        pageSeoTitle={props.pageSeoTitle}
        pageDescription={props.pageDescription}
      >
        {props.children}
      </PageContainer>
    </SideMenu>
  );
}
